import styled from 'styled-components'
import whiteWithText from '@assets/icons/JWalletLogoWithTextWhite.svg'
import blackText from '@assets/icons/JWalletLogoWithTextColor.svg'
import blackWithBlackText from '@assets/icons/JWalletLogoWithTextBlack.svg'
import circular from '@assets/icons/JagadLogoCircular.svg'

type Props = {
  $widthInPercent?: number
}

export const JagadLogoWhiteWithText = styled.img.attrs({
  src: whiteWithText
})<Props>`
  width: ${({ $widthInPercent }: Props) => $widthInPercent ? `${$widthInPercent}%` : '50%'};
`

export const JagadLogoColorWithBlackText = styled.img.attrs({
  src: blackText
})<Props>``

export const JagadLogoBlackWithBlackText = styled.img.attrs({
  src: blackWithBlackText
})<Props>`
  width: ${({ $widthInPercent }: Props) => $widthInPercent ? `${$widthInPercent}%` : '50%'};
`

export const JagadLogoCircular = styled.img.attrs({
  src: circular
})<Props>`
  width: ${({ $widthInPercent }: Props) => $widthInPercent ? `${$widthInPercent}%` : '50%'};
`
